import db from "../database";
import { SyncData } from "../components/PointOfSale/Restaurant/Tables-Management/SyncData";

const FB_ORDER_CO_FIELDS = {
  salesHistory: "Y",
  fbOrderSync: "N",
  tableSync: "N",
  statusType: "OPN",
  fbOrderStatus: "CO",
  color: "#a7c957",
};

const SPLIT_FB_ORDER_CO_FIELDS = {
  fbOrderStatus: "CO",
  salesHistory: "Y",
  tableSync: "N",
};

const TABLE_RESET_FIELDS = {
  salesHistory: "Y",
  fbOrderSync: "N",
  fbOrderStatus: "CO",
  statusType: "OPN",
  noOfPersons: 0,
  guestName: "",
  waiter: null,
  referredBy: "",
  guestType: "",
  time: null,
  color: "#a7c957",
  tableSync: "N",
  ordered: "N",
  wsData: {},
  items: [],
  lines: [],
};

const MERGED_TABLE_RESET_FIELDS = {
  statusType: "OPN",
  noOfPersons: 0,
  guestName: "",
  waiter: null,
  referredBy: "",
  guestType: "",
  time: null,
  color: "#a7c957",
  tableSync: "N",
  wsData: {},
  items: [],
  lines: [],
};

const markFbOrdersCompleted = async (fbOrders, sOrderID, coFields = FB_ORDER_CO_FIELDS) => {
  const completed = [];
  for (const fbOrder of fbOrders) {
    if (fbOrder.fbOrderStatus === "IP") {
      Object.assign(fbOrder, {
        ...coFields,
        sOrderID,
        wsData: {},
        cart: { ...fbOrder.cart, items: [] },
        lines: [],
      });
      await db.fbOrderData.put(fbOrder);
      completed.push(fbOrder);
    }
  }
  return completed;
};

export const cleanupNormalTable = async (tableRecord, tblData, sOrderID) => {
  Object.assign(tableRecord, { ...TABLE_RESET_FIELDS });

  const fbOrders = await db.fbOrderData.where("cwrFbTableId").equals(tblData.cwrFbTableId).toArray();
  await markFbOrdersCompleted(fbOrders, sOrderID);

  await db.tableData.put(tableRecord, tableRecord.cwrFbTableId);
  SyncData(tableRecord, "upsertTableStatus");

  const currentOrder = fbOrders.find((o) => o.sOrderID === sOrderID);
  if (currentOrder) {
    await SyncData(currentOrder, "upsertFbOrder");
  }
};

export const cleanupMergedTables = async (tableRecord, sOrderID) => {
  const parentId = tableRecord.cwrFbTableId;
  const childIds = (tableRecord.merge || []).map((m) => m.fbMTableId);
  const allIds = [parentId, ...childIds];

  const fbOrders = await db.fbOrderData.where("cwrFbTableId").equals(parentId).toArray();
  await markFbOrdersCompleted(fbOrders, sOrderID);

  await db.tableData
    .where("cwrFbTableId")
    .anyOf(allIds)
    .modify((t) => {
      Object.assign(t, MERGED_TABLE_RESET_FIELDS);
    });

  await SyncData(
    {
      fbtableStatusId: tableRecord.fbtableStatusId,
      cwrFbTableId: tableRecord.cwrFbTableId,
      cwrFbsectionId: tableRecord.cwrFbsectionId,
      statusType: "OPN",
      noOfPersons: 0,
      guestName: "",
      guestType: "",
      referredBy: "",
      waiter: tableRecord.waiter || null,
      merge: tableRecord.merge,
    },
    "upsertTableStatus"
  );

  await db.tableData
    .where("cwrFbTableId")
    .anyOf(allIds)
    .modify((t) => {
      t.merge = [];
      t.isMergedParent = "N";
      t.isMergedChild = "N";
      t.parentTableId = null;
      t.mergedTableIds = [];
      t.displayName = t.name;
    });

  await SyncData(tableRecord, "upsertFbOrder");
};

export const cleanupSplitTable = async (fbOrders, sOrderID) => {
  const completed = await markFbOrdersCompleted(fbOrders, sOrderID, SPLIT_FB_ORDER_CO_FIELDS);
  for (const fbOrder of completed) {
    await SyncData(fbOrder, "upsertFbOrder");
  }
};
